import { Merchant } from '../../../types/merchant';

export const transformMerchant = (document: any): Merchant | null => {
  if (!document.exists) {
    return null;
  }

  const data = document.data({ serverTimestamps: 'estimate' });

  if (!data) {
    return null;
  }

  return {
    id: document.id,
    status: data.status,
    econtStoreID: data.econtStoreID,
    econtConnected: data.econtConnected,
    hasOrderWebhook: data.hasOrderWebhook,
    hasCarrierService: data.hasCarrierService,
    createdAt: data.createdAt.toDate(),
    updatedAt: data.updatedAt.toDate()
  };
};
